import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../config/axiosConfig";

export const uploadTrainingFile = createAsyncThunk(
  "myTrainingFileUpload/uploadTrainingFile",
  async ({ trainingId, selectedCategory, files }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("trainingId", trainingId);
      formData.append("selectedCategory", selectedCategory);

      files.forEach(file => formData.append("files", file));

      const res = await axiosInstance.post(
        `/filedata/mytraining`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getTrainingFiles = createAsyncThunk(
  "myTrainingFileUpload/getTrainingFiles",
  async (trainingId, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(`/filedata/training-files/${trainingId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


const myTrainingFileUploadSlice = createSlice({
  name: "myTrainingFileUpload",
  initialState: {
    loading: false,
    uploadedData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadTrainingFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadTrainingFile.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadedData = action.payload;
      })
      .addCase(uploadTrainingFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

      builder
  .addCase(getTrainingFiles.pending, (state) => {
    state.loading = true;
    state.error = null;
  })
  .addCase(getTrainingFiles.fulfilled, (state, action) => {
    state.loading = false;
    state.uploadedData = action.payload; // store file list
  })
  .addCase(getTrainingFiles.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

  },
});

export default myTrainingFileUploadSlice.reducer;
